module.exports = __webpack_public_path__ + "img/Character_Cyno_Thumb.d78efa53.png";